"use strict";

var _interopRequireDefault = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime@7.17.8@@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime-corejs2@7.17.8@@babel/runtime-corejs2/helpers/toConsumableArray.js"));

require("vant/es/toast/style");

var _toast = _interopRequireDefault(require("vant/es/toast"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime-corejs2@7.17.8@@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _index = require("@/api/user/index");

var _voPages = _interopRequireDefault(require("vo-pages"));

require("vo-pages/lib/vo-pages.css");

var _betterScroll = _interopRequireDefault(require("better-scroll"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'myPerformance',
  components: {},
  props: {},
  data: function data() {
    return {
      total: 0,
      page: 0,
      list: [],
      refreshing: false,
      loading: false,
      //是否加载
      finished: false,
      //加载是否完成
      hd: ['标准保费', '保费', '总收入',
      /*    '佣金',
          '推荐奖',
          '管理奖',*/
      '操作'],
      bd: [],
      month: [],
      bscroll: ''
    };
  },
  computed: {},
  watch: {},
  created: function created() {},
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _this;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log('mounted');
              _context2.next = 3;
              return this.fetchData();

            case 3:
              console.log('this.bd');
              console.log(this.bd);
              _this = this;
              setTimeout( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this.scollInit();

                      case 2:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })), 1000);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    scollInit: function () {
      var _scollInit = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var wrap, left, top, bottom1;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                wrap = document.querySelector('.scroll-table-right-content');
                left = document.querySelector('.scroll-table-left-freeze');
                top = document.querySelector('.freeze-top');
                bottom1 = document.querySelector('.freeze-bottom');
                console.log('wrap0000000000000000');
                console.log(wrap);
                this.bscroll = new _betterScroll.default(wrap, {
                  mouseWheel: true,
                  //开启鼠标滚轮
                  disableMouse: false,
                  //启用鼠标拖动
                  disableTouch: false,
                  //启用手指触摸
                  scrollX: true,
                  scrollY: true,
                  momentum: true,
                  swipeTime: 300,
                  probeType: 3,
                  bounce: {
                    top: true,
                    bottom: true,
                    left: true,
                    right: true
                  }
                });
                console.log(this.bscroll);
                this.bscroll.on("scroll", function (e) {
                  left.style = "transform:translate(0px, ".concat(e.y, "px) translateZ(0px)");
                  top.style = "transform:translate( ".concat(e.x, "px,0px) translateZ(0px)");
                });

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function scollInit() {
        return _scollInit.apply(this, arguments);
      }

      return scollInit;
    }(),
    detail: function detail(article) {},
    // 上拉刷新 清空数据
    onRefresh: function onRefresh() {
      this.bscroll.refresh(); // 清空列表数据

      this.finished = false; // 重新加载数据 将 loading 设置为 true，表示处于加载状态

      this.loading = true;
      this.page = 0;
      this.fetchData();
    },
    fetchData: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.page++; //如果刷新

                if (this.refreshing) {
                  this.list = [];
                  this.refreshing = false;
                }

                _context4.next = 4;
                return (0, _index.getPerformanceList)({
                  page: this.page
                });

              case 4:
                res = _context4.sent;

                if (!(res.code > 0)) {
                  _context4.next = 13;
                  break;
                }

                (0, _toast.default)(res.message);
                this.finished = true;
                this.list = [];
                this.loading = false;
                return _context4.abrupt("return");

              case 13:
                this.total = res.data.meta.total;

                if (this.list.length > 0) {
                  this.list = [].concat((0, _toConsumableArray2.default)(this.list), (0, _toConsumableArray2.default)(res.data.data));
                } else {
                  this.list = res.data.data;
                }

                if (this.list.length > 0) {
                  //月份
                  this.month = this.list.map(function (v) {
                    return v.grant_month;
                  });
                  this.bd = this.list.map(function (v) {
                    return [v.standard_amount, v.policy_amount, v.amount,
                    /*   v.insure_amount,
                       v.recommend_amount,
                       v.manage_amount,*/
                    ''];
                  });
                }

                this.loading = false; // 加载状态结束

                console.log(this.list.length + '-----' + this.total);

                if (this.list.length >= this.total) {
                  this.finished = true; // // 数据全部加载完成
                }

              case 19:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function fetchData() {
        return _fetchData.apply(this, arguments);
      }

      return fetchData;
    }(),
    viewDetail: function viewDetail(month) {
      this.$router.push({
        name: 'userPerformanceDetail',
        query: {
          month: month
        }
      });
    }
  }
};
exports.default = _default;